import React from 'react';
import { colors } from '../../utils/constants';

const LoginForm = ({ password, setPassword, loginError, handleLogin }) => (
  <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center">
    <div className="bg-white p-10 rounded-2xl shadow-2xl max-w-md w-full mx-4">
      <div className="text-center mb-8">
        <div className="flex justify-center mb-6">
          <img src="/sv-logo-1.webp" alt="Service Ventures" className="h-24 w-auto" />
        </div>
      </div>

      <div className="space-y-6">
        <div>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleLogin(e)}
            className="w-full px-4 py-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg"
            placeholder="Enter meeting password"
            autoFocus
          />
        </div>

        {loginError && (
          <div className="bg-red-50 border border-red-200 rounded-xl p-4">
            <p className="text-red-600 text-sm font-medium">{loginError}</p>
          </div>
        )}

        <button
          onClick={handleLogin}
          className="w-full text-white py-4 px-6 rounded-xl hover:opacity-90 transition-all duration-200 font-semibold text-lg shadow-lg"
          style={{backgroundColor: colors.navyBlue}}
        >
          Enter
        </button>
      </div>
      
      <div className="mt-8 pt-6 border-t border-gray-200">
        <p className="text-xs text-gray-500 text-center leading-relaxed">
          This portal contains confidential board materials.<br />
          Authorized access only.
        </p>
      </div>
    </div>
  </div>
);

export default LoginForm;